import { apiConfig } from "core-lib/config/config";
import { DictType } from "core-lib/types/Helper";
import { MapDataType } from "core-lib/types/Map";
import { getMethod } from "core-lib/utils/apiV2";

const serializer = (data): MapDataType => ({
  lat: data.latitude,
  lng: data.longitude,
  state: data.state,
  stateCode: data.state_code,
  city: data.city,
  pincode: data.pincode,
  streetAddress: null,
  locality: data.area,
  houseNo: null,
  district: data?.district,
  infraCity: data?.infra_city,
  zoneName: data?.zone_name,
  stateId: data?.state_id,
  addressLine2: data?.address_line2,
});

export async function fetchAddressFromLatLng({
  lat,
  lng,
  pincode,
  radius = 5000,
  flow,
  requiredFields = ["latitude", "longitude", "pincode", "city", "state"],
}: DictType) {
  const url = `${apiConfig("infra", "v4")}/infra/location/details/`;
  const params: any = {};
  if (lat && lng) {
    params.search_type = "geolocation_search";
    params.latitude = lat;
    params.longitude = lng;
    params.radius = radius;
    if (flow) {
      params.flow = flow;
    }
  } else if (pincode) {
    params.search_type = "pincode_search";
    params.pincode = pincode;
  }
  const { response, error }: any = await getMethod({ endPoint: url, params });
  if (response?.data?.results?.length) {
    const location = response.data?.results[0];
    const isValid = requiredFields.every((el) => location[el]);
    if (isValid) {
      return { locationData: serializer(location) };
    } else {
      return { error: "Oops! we could not find location details" };
    }
  }

  if (error) {
    return { error };
  }

  return { error: "Oops! we could not find location details" };
}
